 import { gsap } from 'gsap';
 import { ScrollTrigger } from 'gsap/ScrollTrigger';

// const { $ } = window
// const $body = $(document.body)
export default {
    init() {
		// gsap.registerPlugin(ScrollTrigger)
		 animateArchive();
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
}

function animateArchive() {
	animateHero();
}

function animateHero() {
	let $anchor = $('.page-default-content')
	if(!$anchor.length) { return }

	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: $anchor,
		},
		defaults: {
			opacity: 1,
			delay: 0.2,
			duration: 0.25,
			stagger:0.1,
			ease:'power1.out',
			y: 0
		}
	})

	//gsap.set('.hero > *', { opacity: 0})
	gsap.set('.page-default-content h1', { y: 4})
	gsap.set('.page-default-content > *:not(h1):not(.archive-list)', {opacity: 0, y: 3})
	gsap.set('.archive-list h2, .archive-list .archive-list-post', {opacity: 0, y: 3})
	tl.to('.page-default-content h1', { x: 0})
		.to('.page-default-content > *:not(h1):not(.archive-list)', { y: 0}, '-=0.25')
		.to('.archive-list h2, .archive-list .archive-list-post', { y: 0}, '-=0.25')
}
